module.exports = __webpack_public_path__ + "img/trendingIcon.de9e4d60.svg";